import { __exports as contextService } from './_virtual-contextService.js';
import { __require as requireCultureFormatter } from './vp-js-token-engine-build-services-cultureFormatter.js';

var hasRequiredContextService;

function requireContextService () {
	if (hasRequiredContextService) return contextService;
	hasRequiredContextService = 1;

	Object.defineProperty(contextService, "__esModule", {
	  value: true
	});
	contextService.ContextService = void 0;
	var _cultureFormatter = requireCultureFormatter();
	class ContextService {
	  getCulture(scope) {
	    const cultureFormatter = new _cultureFormatter.CultureFormatter();
	    const culture = scope.context.environments.culture;
	    const formattedCulture = cultureFormatter.format(culture);
	    return formattedCulture;
	  }
	  getTenant(scope) {
	    return scope.context.environments.tenant;
	  }
	  getUrlClient(scope) {
	    return scope.context.environments.urlClient;
	  }
	}
	contextService.ContextService = ContextService;
	
	return contextService;
}

export { requireContextService as __require };
//# sourceMappingURL=vp-js-token-engine-build-services-contextService.js.map
